import styled from 'styled-components';
import { Popup, type PopupProps } from '@elfsight/widget-modal';
import * as RadixDialog from '@radix-ui/react-dialog';
import { ModalContent } from './modal-content';
import type { FilterModalProps } from './types';

export type FiltersPopupProps = FilterModalProps &
  Omit<PopupProps, 'children' | 'width' | 'onCloseRequest'> & {
    width?: number;
    borderRadius?: number;
  };

export const FiltersPopup = ({
  title,
  children,
  trigger,
  displayClearButton,
  clearButton,
  applyButton,
  borderRadius = 20,
  width = 640,
  margin = 40,
  show,
  onCloseRequest,
  onOpenRequest,
  onApplyRequest,
  onDiscardRequest,
  onResetRequest,
  onClearRequest,
  ...forwardingProps
}: FiltersPopupProps) => {
  return (
    <RadixDialog.Root open={show}>
      <RadixDialog.Trigger onClick={onOpenRequest} asChild>
        {trigger}
      </RadixDialog.Trigger>
      <Popup
        fixed
        show={show}
        onCloseRequest={() => {
          onCloseRequest();
          onDiscardRequest();
        }}
        closeOnEscape
        closeOnOutsideClick
        disableScroll
        withBackdrop
        backdropColor="rgba(17,17,17,0.7)"
        fit
        margin={margin}
        width={width}
        ariaLabel={title}
        {...forwardingProps}
      >
        <Content
          title={title}
          onCloseRequest={onCloseRequest}
          onApplyRequest={onApplyRequest}
          onResetRequest={onResetRequest}
          onDiscardRequest={onDiscardRequest}
          onClearRequest={onClearRequest}
          displayClearButton={displayClearButton}
          clearButton={clearButton}
          applyButton={applyButton}
          $borderRadius={borderRadius}
        >
          {children}
        </Content>
      </Popup>
    </RadixDialog.Root>
  );
};

const Content = styled(ModalContent)<{ $borderRadius: number }>`
  box-shadow:
    0 4px 16px 0 rgba(0, 0, 0, 0.3),
    0 0 0 1px rgba(255, 255, 255, 0.1) inset;
  border-radius: ${({ $borderRadius }) => $borderRadius}px;
`;
